import clsx from 'clsx';
import {
  getQmeeNavLinks,
  lifepointsNavLinks,
  mobiNavLinks,
} from 'components/molecules/NavLinks/mobiNavLinks';
import NavLinks from 'components/molecules/NavLinks/NavLinks';
import React from 'react';
import classes from './LoggedInFooterMenu.module.scss';
import { NavLink } from 'components/molecules/NavLinks/mobiNavLinks';
import { useIsLoggedIn } from 'components/templates/AuthenticationProvider/AuthenticationProvider';

export interface Props {
  className?: string;
}

type Tenant = 'lifepoints' | 'mobiworkx' | 'qmee';

const LoggedInFooterMenu: React.FC<Props> = ({ className }: Props) => {
  const isLoggedIn = useIsLoggedIn();
  const qmeeNavLinks = getQmeeNavLinks(isLoggedIn);

  const checkTenant = (tenantLinks: string) => {
    const tenantLink: Record<Tenant, NavLink[]> = {
      lifepoints: lifepointsNavLinks,
      mobiworkx: mobiNavLinks,
      qmee: qmeeNavLinks,
    };
    return tenantLink[tenantLinks as Tenant] || mobiNavLinks;
  };

  return (
    <div className={clsx(classes.root)} data-logged-in-footer-menu>
      <NavLinks
        navLinkArr={checkTenant(process.env.NEXT_PUBLIC_TENANT || 'mobiworkx')}
        borderPosition="top"
        isFooterNav
      />
    </div>
  );
};

export default LoggedInFooterMenu;
